import { render, staticRenderFns } from "./FileJsonIcon.vue?vue&type=template&id=00f04ea7&scoped=true&"
import script from "./FileJsonIcon.vue?vue&type=script&lang=js&"
export * from "./FileJsonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f04ea7",
  null
  
)

export default component.exports